<template>
  <div>
    <template v-if="grouped">
      <BaseSelect :value="selected"
                  :options="expenses_groups"
                  :select-label="label"
                  label="title"
                  track-by="id"
                  group-label="title"
                  group-values="childs"
                  :group-select="false"
                  :searchable="true"
                  :show-labels="false"
                  :allow-empty="false"
                  @select="$emit('input', $event)"
                  @remove="$emit('input', null)"/>
    </template>
    <template v-else>
      <BaseSelect :value="selected"
                  :options="expenses"
                  :select-label="label"
                  label="title"
                  track-by="id"
                  :searchable="true"
                  :show-labels="false"
                  :allow-empty="false"
                  @select="$emit('input', $event)"
                  @remove="$emit('input', null)"/>
    </template>
  </div>
</template>

<script>
import BaseSelect from "@/components/UI/BaseSelect/BaseSelect";

export default {
  name: "ExpenseSelect",
  components: {BaseSelect},
  props: {
    label: {
      type: String,
      default: ''
    },
    selected: {
      required: true
    },
    grouped: {
      type: Boolean,
      required: true
    },
    expenses: {
      type: Array,
      required: true
    },
    expenses_groups: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>

</style>